import React from 'react';
import FormatUtils from 'utils/format';
import { Box, Flex } from '@spothero/ui';
// This is a jsx-ified version of the function formatRatePrice from src/js/utils/spot.js 🧑‍🍳😙🤌
// TODO refactor all uses of formatRatePrice and deprecate
const DisplayPriceFormatted = ({ price, currencyType, textToAppend = '', }) => {
    const { displayPrice } = FormatUtils.price(Number(price));
    return (<Flex alignItems="center" pb="1.5" className="DisplayPriceFormatted-container">
            <Box className="DisplayPriceFormatted-CurrencySymbol">
                {FormatUtils.currencySymbol(currencyType)}
            </Box>
            <Box className="DisplayPriceFormatted-Price">{displayPrice}</Box>
            {textToAppend && (<Box fontSize="sm" fontWeight="normal" className="DisplayPriceFormatted-TextToAppend">
                    {textToAppend}
                </Box>)}
        </Flex>);
};
export default DisplayPriceFormatted;
